import { createRouteRef } from '@backstage/frontend-plugin-api';

/** Route of the TC agentic demonstrator; separate so pages can link without a cycle. */
export const agenticRouteRef = createRouteRef();
